export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";

export const MARK_MENTOR_ACTIVE_SUCCESS = "MARK_MENTOR_ACTIVE_SUCCESS";
export const LOAD_LOCALIZATIONS_SUCCESS = "LOAD_LOCALIZATIONS_SUCCESS";
export const LOAD_QUEUED_MENTORS_SUCCESS = "LOAD_QUEUED_MENTORS_SUCCESS";
export const LOAD_ACTIVE_MENTORS_SUCCESS = "LOAD_ACTIVE_MENTORS_SUCCESS";
export const LOAD_COMPLETED_MENTORS_SUCCESS = "LOAD_COMPLETED_MENTORS_SUCCESS";
export const GET_MENTOR_USER_INFO_SUCCESS = "GET_MENTOR_USER_INFO_SUCCESS";
export const LOAD_CURRENT_MENTORS_BY_ID_SUCCESS = "LOAD_CURRENT_MENTORS_BY_ID_SUCCESS";

export const LOAD_UPCOMING_MENTORS_SUCCESS = "LOAD_UPCOMING_MENTORS_SUCCESS";
export const LOAD_PARTIALLY_COMPLETE_SESSIONS_SUCCESS = "LOAD_PARTIALLY_COMPLETE_SESSIONS_SUCCESS";

export const LOAD_ASSIGNED_MENTORS_SUCCESS = "LOAD_ASSIGNED_MENTORS_SUCCESS";
// By convention, actions that end in "_SUCCESS" are assumed to have been the result of a completed
// API call. But since we're doing an optimistic delete, we're hiding loading state.
// So this action name deliberately omits the "_SUCCESS" suffix.
// If it had one, our apiCallsInProgress counter would be decremented below zero
// because we're not incrementing the number of apiCallInProgress when the delete request begins.
export const CURRENT_ADD_CHAT_OPTIMISTIC = "CURRENT_ADD_CHAT_OPTIMISTIC";
export const CURRENT_REQUEST_PHOTO_OPTIMISTIC = "CURRENT_REQUEST_PHOTO_OPTIMISTIC";
// export const CURRENT_ADD_PHOTO_OPTIMISTIC = "CURRENT_ADD_PHOTO_OPTIMISTIC";
export const CURRENT_ADD_PHOTO_TAG_OPTIMISTIC = "CURRENT_ADD_PHOTO_TAG_OPTIMISTIC";

export const CURRENT_SET_SESSION_STATE = "CURRENT_SET_SESSION_STATE";

export const CURRENT_PHOTOS_ADDED_BY_LOCAL_STORAGE = "CURRENT_PHOTOS_ADDED_BY_LOCAL_STORAGE";
export const BEGIN_SESSION_SUCCESS = "BEGIN_SESSION_SUCCESS";
